import { Box, Grid } from '@mui/material'
import EditActionPanel, {
    EditActionPanelProps,
} from 'components/Form/EditActionPanel'
import { useScreenSize } from 'hooks/useScreenSize/useScreenSize'
import { ReactNode } from 'react'

export type FormWithActionButtonsProps = EditActionPanelProps & {
    children: ReactNode
    showTopActionButtons?: boolean
    isDialog?: boolean
    discardText?: string
}

function FormWithActionButtons(props: FormWithActionButtonsProps) {
    const {
        children,
        showTopActionButtons = false,
        isDialog = false,
        ...actionButtonsProps
    } = props
    const { isMobile } = useScreenSize()

    function ActionButtons() {
        return <EditActionPanel {...actionButtonsProps} />
    }

    if (!isMobile || isDialog)
        return (
            <Grid container spacing={2}>
                {showTopActionButtons && (
                    <Grid
                        item
                        xs={12}
                        sx={{
                            mt: -5,
                        }}
                    >
                        <ActionButtons />
                    </Grid>
                )}
                <Grid item xs={12}>
                    {children}
                </Grid>
                <Grid item xs={12}>
                    <ActionButtons />
                </Grid>
            </Grid>
        )

    return (
        <Box display={'flex'} width={'100%'}>
            <Box width={'100%'} sx={{ mb: (theme) => theme.spacing(8) }}>
                {children}
            </Box>

            <Box
                position={'fixed'}
                bottom={0}
                left={0}
                bgcolor={'background.paper'}
                p={2}
                width={'100%'}
                zIndex={1001}
            >
                <ActionButtons />
            </Box>
        </Box>
    )
}

export default FormWithActionButtons
